<template>
  <div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span class="ess">작업기간</span></label>
      <div class="col-4 pt-2">
        <DatePicker class="form-control" type="date" range :append-to-body="true"
          :value="permit.workPeriod"
          :clearable="false" :editable="false"
          :disabled-date="scheduleDateDisabledFn"
          @change="(val) => { permit.workPeriod = val; }"
          style="font-size: 12px;" input-class="calendar-input">
          <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
        </DatePicker>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span>고소작업 종류</span></label>
      <div class="col-10 pt-2">
        <label class="md-check mr-20" v-for="t in highAltitudePermitTypes" :key="t">
          <input type="checkbox" v-model="permit.workTypes" :value="t">
          <i class="blue"></i>{{ t }}
        </label>
        <label class="md-check mr-10">
          <input type="checkbox" v-model="permit.isOther">
          <i class="blue"></i>기타 고소작업대
        </label>
        <input v-if="permit.isOther" type="text" class="form-control mt-5"
               v-model="permit.otherText" placeholder="기타 고소작업대 내용 입력 (필수)"
               :style="{ maxWidth:'300px', ...((permit.otherText || '').trim() ? {} : { borderColor:'#eb5757' }) }">
        <div v-if="permit.isOther && !(permit.otherText || '').trim()"
             style="color:#eb5757; font-size:11px; margin-top:4px;">기타 고소작업대 내용은 필수 입력입니다.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HighAltitudePermit',
  props: {
    permit: {
      type: Object,
      required: true
    },
    scheduleDateDisabledFn: {
      type: Function,
      default: () => false
    }
  },
  data() {
    return {
      highAltitudePermitTypes: ['이동식사다리', '달비계', '이동식비계', '말비계', '시스템비계', '차량형 고소작업대', '시저형 고소작업대']
    }
  }
}
</script>